import { takeLatest, all } from 'redux-saga/effects';
import { DATA_AUDIT_ACTIONS, FACILITY_AND_ANCILLARY_ACTIONS } from 'config';
import {
  getdDrgByHospitalCountWithNtypeSaga,
  getDistingDRGByNegotiationsSaga,
  getDrgReferenceTableSaga,
  getHospitalCountDrgSaga,
  getPCHbillingCodeModifiersSaga,
  getPCHcitySaga,
  getPCHcodeTypeSaga,
  getPCHl1descriptionSaga,
  getPCHnegotiatedTypeSaga,
  getPCHreportingEntitySaga,
  getProcedureCostByHospitalSaga,
  getProviderDrgByHospitalSaga,
  getSaticBCBVDataSaga,
  getSaticChartDataSaga,
  getStateDrgByHospitalSaga,
  npiAcrossCountrySaga
} from './dataAudit';
import {
  getAncillaryListSaga,
  getBillingCodeTypeListSaga,
  getCategoryListSaga,
  getDRGBreakdownSaga,
  getDRGCodeCategorySaga,
  getDRGcostallentitySaga,
  getDRGProviderNameSaga,
  getDRGReportingEntityNameSaga,
  getFilteredDRGBillingCodeSaga,
  getFilteredDRGBillingCodeTypeSaga,
  getFilteredDRGHospitalListSaga,
  getFilteredDRGListDataSaga,
  getFilteredDRGPayerListSaga,
  getHospitalListSaga,
  getLevel1DescListSaga,
  getModifierListSaga,
  getNpiListSaga,
  getOverviewCPTListSaga,
  getOverviewDRGListSaga,
  getPayerListSaga,
  getPayerPriceCompListSaga,
  getPayerProcCountListSaga,
  getProcedureNameListSaga,
  getProceduresCatListSaga,
  getRegionalMapDataListSaga,
  getStateMapDataListSaga,
  getTopPrefEntityListSaga,
  gettopProceduresL4Saga,
  gettopProceduresNonPrefL4Saga,
  getHistoricalRequestsSaga,
  placeReRequestSaga,
  getFacilityScoreCardScoresSaga,
  getFacilityScoreCardNPIsSaga,
  getProviderExtractFiltersSaga,
  getProviderExtractResultsSaga,
  getProviderExtractResultsChartsSaga,
  getFilteredDRGAncillaryListSaga
} from './ancillaryAndFacility';

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    // Data Audit requests
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_DISTING_DRG_BY_NEGOTIATIONS, getDistingDRGByNegotiationsSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE, getdDrgByHospitalCountWithNtypeSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_DRG_REFERENCE_TABLE, getDrgReferenceTableSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_HOSPITAL_COUNT_DRG, getHospitalCountDrgSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_NPI_DISTRIBUTION_ACROSS_COUNTRY, npiAcrossCountrySaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PCH_BILLING_CODE_MODIFIER, getPCHbillingCodeModifiersSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PCH_CITY, getPCHcitySaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PCH_CODE_TYPE, getPCHcodeTypeSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PCH_L1_DESCRIPTION, getPCHl1descriptionSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PCH_NEGOTIATED_TYPE, getPCHnegotiatedTypeSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PCH_REPORTING_ENTITY, getPCHreportingEntitySaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PROCEDURE_COST_BY_HOSPITAL, getProcedureCostByHospitalSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_PROVIDER_DRG_BY_HOSPITAL, getProviderDrgByHospitalSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_STATE_DRG_BY_HOSPITAL, getStateDrgByHospitalSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_STATIC_BCBV_DATA, getSaticBCBVDataSaga),
    yield takeLatest(DATA_AUDIT_ACTIONS.REQUEST_STATIC_CHART_DATA, getSaticChartDataSaga),

    // Facility And Ancillary Requests
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_ANCILLARY_LIST, getAncillaryListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_BILLING_CODE_TYPE_LIST, getBillingCodeTypeListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_CATEGORY_LIST, getCategoryListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_BREAKDOWN, getDRGBreakdownSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_CODE_CATEGORY, getDRGCodeCategorySaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_COST_ALLENTITY, getDRGcostallentitySaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_PROVIDER_NAME, getDRGProviderNameSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_REPORTING_ENTITY_NAME, getDRGReportingEntityNameSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGBILLING_CODE_TYPE, getFilteredDRGBillingCodeTypeSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGBILLING_CODES, getFilteredDRGBillingCodeSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGHOSPITAL_LIST, getFilteredDRGHospitalListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_ANCILLARY_LIST, getFilteredDRGAncillaryListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGLIST_DATA, getFilteredDRGListDataSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGPAYER_LIST, getFilteredDRGPayerListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_HOSPITAL_LIST, getHospitalListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_L1_DESCRIPTION, getLevel1DescListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_MODIFIER_LIST, getModifierListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_NPI_LIST, getNpiListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_OVERVIEW_CPT_LIST, getOverviewCPTListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_OVERVIEW_DRG_LIST, getOverviewDRGListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_LIST, getPayerListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_PRICE_DIFF_LIST, getPayerPriceCompListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_PROC_COUNT, getPayerProcCountListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROCEDURE_CATEGORY, getProceduresCatListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROCEDURE_NAME_LIST, getProcedureNameListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_REGIONAL_MAP_DATA_LIST, getRegionalMapDataListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_STATE_MAP_DATA_LIST, getStateMapDataListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PREF_ENTITY_LIST, getTopPrefEntityListSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PROCEDURE_L4, gettopProceduresL4Saga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PROCEDURE_NON_PREF_L4, gettopProceduresNonPrefL4Saga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_HISTORICAL_REQUESTS, getHistoricalRequestsSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PLACE_RE_REQUEST, placeReRequestSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_FACILITY_SCORECARD_SCORES, getFacilityScoreCardScoresSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_FACILITY_SCORECARD_NPIS, getFacilityScoreCardNPIsSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_FILTERS, getProviderExtractFiltersSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_RESULT, getProviderExtractResultsSaga),
    yield takeLatest(FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_RESULT_CHARTS, getProviderExtractResultsChartsSaga)
  ]);
}
